var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.$mainMenu),function(item){return _c('li',{key:item.slug},[_c('router-link',{attrs:{"to":{ path: (_vm.lang ? '/' + _vm.lang + '/' : '/') + item.uri }}},[_vm._v(" "+_vm._s(_vm.$t(`mainMenu.${item.slug}`))+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }